import dynamic from 'next/dynamic';
import React from 'react';

const CircularProgressBar = dynamic(() => import('~/src/atoms/CircularProgressBar'));

const filterDisplayType = (featureStats = [], type = 1) => {
  return featureStats.filter((feature) => feature.display_type === type);
};

const DisplayTypeOne = ({ feature }) => {
  const { average, count, feature_title: featureTitle } = feature;
  const percentage = (average / 5) * 100;
  return (
    <div className="flex flex-col items-center justify-center pt-5 pb-1 self-start text-center">
      <div className="text-md font-semibold mb-5">
        <CircularProgressBar percentage={percentage} value={average} color={progressBarColors[Math.floor(average)]} />
      </div>
      <span className="text-md text-darkOnyx-600 mb-1 leading-md">{featureTitle || ''}</span>
      <span className="text-sm text-darkOnyx-200 leading-xs">{count} ratings</span>
    </div>
  );
};

const DisplayTypeTwo = ({ feature }) => {
  const { percentage_text: percentageText = [] } = feature;
  return (
    <div className="col-span-2 text-md">
      {percentageText?.map((text) => {
        return (
          <div key={text} className="flex text-darkOnyx-400 mt-4">
            <span className=" text-darkOnyx-600 mr-3">•</span>
            <span dangerouslySetInnerHTML={{ __html: text }} />
          </div>
        );
      })}
    </div>
  );
};

export default function RatingsCircularBar({ featureStats = [] }) {
  return (
    <>
      {filterDisplayType(featureStats, 1).map((feature) => {
        return <DisplayTypeOne key={feature.feature_id} feature={feature} />;
      })}
      {filterDisplayType(featureStats, 2).map((feature) => {
        return <DisplayTypeTwo key={feature.feature_id} feature={feature} />;
      })}
    </>
  );
}

const progressBarColors = {
  1: '#D63333',
  2: '#FFCC10',
  3: '#5E9400',
  4: '#5E9400',
  5: '#5E9400',
};
